export const header = {
	aboutMeTitle: 'Sobre Mim',
	careerTitle: 'Carreira',
	skillsTitle: 'Habilidades',
	projectsTitle: 'Projetos',
};
